import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-perfil-crezcamos-historia',
  templateUrl: './perfil-crezcamos-historia.component.html',
  styleUrls: ['./perfil-crezcamos-historia.component.scss']
})
export class PerfilCrezcamosHistoriaComponent { 
  @Input() informacionPerfil: any;
}
